module.exports = __webpack_public_path__ + "TB_Eating_Ambience_B.wav.2395a907.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/eating/TB_Eating_Ambience_B.wav.mp3
// module id = 491
// module chunks = 0